<template>
  <button
    class="sc-microphone-input--send-icon-wrapper"
    @click.prevent="onClick"
  >
    <svg
      version="1.1"
      class="sc-microphone-input--send-icon"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="37.393px"
      height="37.393px"
      viewBox="0 0 384 512"
    >
      <g id="Layer_2">
        <path
          :style="{fill: color}"
          d="M96 96l0 160c0 53 43 96 96 96s96-43 96-96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96S96 43 96 96zM320 240l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24z"
        />
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped>
.sc-microphone-input--send-icon-wrapper {
  background: none;
  border: none;
  padding: 0px;
  margin: 0px;
  outline: none;
  margin-left: 10px
}

.sc-microphone-input--send-icon-wrapper:focus {
  outline: none;
}

.sc-microphone-input--send-icon {
  height: 20px;
  width: 20px;
  cursor: pointer;
  align-self: center;
  outline: none;
}

.sc-microphone-input--send-icon:hover path {
  filter: contrast(15%);
}
</style>
